import React, { Component } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Row,
  Col
} from "reactstrap";

const items = [
  {
    src: "/images/iom-portfolio.jpg",
    altText: "IOM - LINK IT",
    // header: "HumanKind",
    caption:
      "Skills Profile Tool created to help accelerate access to the labour market for Syrian refugees"
  },
  {
    src: "/images/humankindorg-portfolio.jpg",
    altText: "HumanKind",
    // header: "HumanKind",
    caption:
      "Strengthening individuals and families through care, counseling and education"
  },
  {
    src: "/images/link-it-portfolio.jpg",
    altText: "DoS",
    // header: "HumanKind",
    caption:
      "Directory of services for case workers oriented for refugees, asylum seekers and organisations working with them."
  }
];

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === items.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === 0
        ? items.length - 1
        : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = items.map(item => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          <img src={item.src} alt={item.altText} />
          <CarouselCaption
            captionText={item.caption}
            captionHeader={item.header}
          />
        </CarouselItem>
      );
    });

    return (
      <Row className="justify-content-around">
        <Col sm="12" md="12" lg="12">
          <h3 className="carousel--title">Our Projects</h3>
        </Col>
        <Col sm="12" md="10" lg="10">
          <Carousel
            activeIndex={activeIndex}
            next={this.next}
            previous={this.previous}
          >
            <CarouselIndicators
              items={items}
              activeIndex={activeIndex}
              onClickHandler={this.goToIndex}
            />
            {slides}
            <CarouselControl
              direction="prev"
              directionText="Previous"
              onClickHandler={this.previous}
            />
            <CarouselControl
              direction="next"
              directionText="Next"
              onClickHandler={this.next}
            />
          </Carousel>
        </Col>
      </Row>
    );
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/pages/Home/Portfolio.js